<template>
  <v-btn
    v-bind="$attrs"
    :color="color"
    variant="outlined"
    @click="$emit('update:model-value', val)"
  >
    <v-icon v-if="icon" class="mr-2" color="primary">
      {{ icon }}
    </v-icon>
    <span class="qtm-label text-mid-grey" v-text="label" />
  </v-btn>
</template>

<script setup lang="ts">
export interface Props {
  icon?: string
  label?: string
  val: string
  modelValue?: string
}

const props = withDefaults(defineProps<Props>(), {
  icon: undefined,
  label: '',
  modelValue: undefined,
})
defineEmits(['update:model-value'])

const active = computed(() => props.modelValue === props.val)
const color = computed(() => (active.value ? 'primary' : 'light-grey'))
</script>
